/* bundle-picker.js -- Present Mushrooms v17 */
(function () {
  'use strict';

  /* ── State ───────────────────────────────────────────────── */
  var _customPriceEl      = null;   // our injected #bp-price-display
  var _selectedBundle     = null;   // currently selected bundle object
  // Price display defense
  var _currentPrice       = null;   // desired price cents
  var _currentCompareAt   = null;   // desired compare-at cents
  var _priceObserver      = null;   // MutationObserver guarding #bp-price-display
  var _plock              = false;  // prevents price observer re-entrancy
  var _priceRetries       = 0;      // cap price observer retries
  // Klarna defense
  var _currentKlarnaPrice = null;   // desired klarna price (cents)
  var _klarnaObserver     = null;   // MutationObserver guarding data-purchase-amount
  var _klock              = false;  // prevents klarna observer re-entrancy
  var _klarnaRetries      = 0;      // cap observer retries

  /* ── Helpers ─────────────────────────────────────────────── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  /* ── Price display ───────────────────────────────────────── */
  function renderPriceInto(el, price, compareAt) {
    if (compareAt && compareAt > price) {
      el.innerHTML =
        '<div class="price__container">' +
          '<div class="price__sale" style="display:block">' +
            '<span class="price-item price-item--sale price-item--last">' + formatMoney(price) + '</span>' +
            '&nbsp;<s class="price-item price-item--regular">' + formatMoney(compareAt) + '</s>' +
          '</div>' +
        '</div>';
    } else {
      el.innerHTML =
        '<div class="price__container">' +
          '<div class="price__regular" style="display:block">' +
            '<span class="price-item price-item--regular">' + formatMoney(price) + '</span>' +
          '</div>' +
        '</div>';
    }
  }

  function createPriceDisplay() {
    /* Target .price--large first (the prominent price near the product title
       in this theme), then fall back to the first .price in the DOM. */
    var original = document.querySelector('.price--large') ||
                   document.querySelector('.price');
    if (!original) return null;
    /* Hide Dawn's .price element — keep it in DOM so Dawn's JS stays happy,
       but make it invisible so only our #bp-price-display shows. */
    original.style.setProperty('visibility', 'hidden', 'important');
    original.style.setProperty('height',     '0',       'important');
    original.style.setProperty('overflow',   'hidden',  'important');
    original.style.setProperty('margin',     '0',       'important');
    original.style.setProperty('padding',    '0',       'important');
    var el = document.createElement('div');
    el.id = 'bp-price-display';
    el.className = original.className;
    original.parentNode.insertBefore(el, original.nextSibling);
    _customPriceEl = el;

    /* Guard against external scripts (e.g. present.js) that target elements
       by class and overwrite our innerHTML with the original product price.
       Works identically to the Klarna MutationObserver defense. */
    if (_priceObserver) { _priceObserver.disconnect(); }
    _plock = false;
    _priceRetries = 0;
    _priceObserver = new MutationObserver(function () {
      if (_plock || _priceRetries >= 10 || _currentPrice === null) return;
      _priceRetries++;
      _plock = true;
      renderPriceInto(el, _currentPrice, _currentCompareAt);
      setTimeout(function () { _plock = false; }, 200);
    });
    _priceObserver.observe(el, { childList: true, subtree: true });

    return el;
  }

  function updatePrice(price, compareAt) {
    _currentPrice     = price;
    _currentCompareAt = compareAt;
    _priceRetries     = 0;

    var el = _customPriceEl;
    /* Guard: if element was detached from DOM (e.g. by a section re-render),
       try to re-anchor by ID, or re-create it entirely. */
    if (!el || !document.body.contains(el)) {
      el = document.getElementById('bp-price-display');
      if (el) {
        _customPriceEl = el;
      } else {
        el = createPriceDisplay();
        if (!el) return;
      }
    }
    /* Lock so our own innerHTML write doesn't trigger the observer */
    _plock = true;
    renderPriceInto(el, price, compareAt);
    setTimeout(function () { _plock = false; }, 200);
  }

  /* ── Klarna OSM update ───────────────────────────────────── */
  function updateKlarna(priceInCents) {
    _currentKlarnaPrice = priceInCents;
    _klarnaRetries      = 0;

    var kl = document.querySelector('klarna-placement');
    if (!kl) return;

    /* Disconnect any previous observer before setting the attribute,
       so our own setAttribute doesn't immediately fire the callback. */
    if (_klarnaObserver) { _klarnaObserver.disconnect(); _klarnaObserver = null; }
    _klock = false;

    kl.setAttribute('data-purchase-amount', String(priceInCents));

    /* Set up a MutationObserver so that if any external script
       (present.js, Klarna's own init, etc.) reverts data-purchase-amount,
       we immediately restore it. Capped at 10 restores to avoid infinite loops. */
    _klarnaObserver = new MutationObserver(function () {
      if (_klock || _klarnaRetries >= 10) return;
      var cur = kl.getAttribute('data-purchase-amount');
      if (cur !== String(_currentKlarnaPrice)) {
        _klarnaRetries++;
        _klock = true;
        kl.setAttribute('data-purchase-amount', String(_currentKlarnaPrice));
        /* Brief unlock delay: MutationObserver fires asynchronously as a
           microtask, so by the time it fires again _klock is already true.
           We reset it after 200 ms to allow future legitimate changes. */
        setTimeout(function () { _klock = false; }, 200);
      }
    });
    _klarnaObserver.observe(kl, { attributes: true, attributeFilter: ['data-purchase-amount'] });

    /* Also call the standard update() APIs after a short delay,
       giving Klarna's scripts time to finish loading before we trigger them.
       NOTE: no element-replace here — that causes section re-renders which
       detach #bp-price-display and make Klarna re-fetch from Shopify. */
    setTimeout(function () {
      var el2 = document.querySelector('klarna-placement');
      if (el2) el2.setAttribute('data-purchase-amount', String(_currentKlarnaPrice));
      try { if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.update(); } catch (e) {}
      try { if (window.Klarna && window.Klarna.OnsiteMessaging) window.Klarna.OnsiteMessaging.update(); } catch (e) {}
    }, 150);
  }

  function setActivePrice(price, compareAt) {
    updatePrice(price, compareAt);
    updateKlarna(price);
  }

  /* ── Variant ID ──────────────────────────────────────────── */
  function setVariantId(variantId) {
    document.querySelectorAll(
      'product-form form[action*="/cart/add"] [name="id"]'
    ).forEach(function (inp) {
      inp.value = String(variantId);
    });
  }

  /* ── Card selection ──────────────────────────────────────── */
  function selectCard(row, card, bundle) {
    row.querySelectorAll('.bundle-picker__card').forEach(function (c) {
      c.classList.remove('bundle-picker__card--selected');
    });
    card.classList.add('bundle-picker__card--selected');
    _selectedBundle = bundle;
    setVariantId(bundle.variantId);
    var ca = (bundle.compareAtPrice && bundle.compareAtPrice > bundle.price)
             ? bundle.compareAtPrice : null;
    setActivePrice(bundle.price, ca);
  }

  /* ── Build picker ────────────────────────────────────────── */
  function buildPicker(config) {
    var bundles = config.bundles;
    if (!bundles || bundles.length === 0) return null;

    var section = document.createElement('div');
    section.className = 'bundle-picker-section';
    section.setAttribute('data-bundle-picker', '');

    var header = document.createElement('div');
    header.className = 'bundle-picker__header';
    header.textContent = 'Opzioni di acquisto:';
    section.appendChild(header);

    var row = document.createElement('div');
    row.className = 'bundle-picker';
    section.appendChild(row);

    var firstCard   = null;
    var firstBundle = null;

    bundles.forEach(function (bundle) {
      var card = document.createElement('div');
      card.className = 'bundle-picker__card' +
        (firstCard === null ? ' bundle-picker__card--selected' : '');

      if (bundle.savePct > 0) {
        var badge = document.createElement('div');
        badge.className = 'bundle-picker__badge';
        badge.textContent = 'Risparmia ' + bundle.savePct + '%';
        card.appendChild(badge);
      }

      if (bundle.imgUrl) {
        var img = document.createElement('img');
        img.src      = bundle.imgUrl;
        img.alt      = bundle.label;
        img.className = 'bundle-picker__img';
        img.onerror  = function () { this.style.display = 'none'; };
        card.appendChild(img);
      }

      var titleEl = document.createElement('div');
      titleEl.className   = 'bundle-picker__title';
      titleEl.textContent = bundle.label;
      card.appendChild(titleEl);

      var subEl = document.createElement('div');
      subEl.className   = 'bundle-picker__subtitle';
      subEl.textContent = bundle.sublabel;
      card.appendChild(subEl);

      var priceBlock = document.createElement('div');
      priceBlock.className = 'bundle-picker__pricing';

      if (bundle.compareAtPrice && bundle.compareAtPrice > bundle.price) {
        var compareEl = document.createElement('div');
        compareEl.className   = 'bundle-picker__compare';
        compareEl.textContent = formatMoney(bundle.compareAtPrice);
        priceBlock.appendChild(compareEl);
      }

      var priceEl = document.createElement('div');
      priceEl.className   = 'bundle-picker__price';
      priceEl.textContent = formatMoney(bundle.price);
      priceBlock.appendChild(priceEl);

      if (bundle.units > 1) {
        var unitLabel = (bundle.sublabel && bundle.sublabel.indexOf('flacone') !== -1)
          ? '/flacone' : '/confezione';
        var perUnitEl = document.createElement('div');
        perUnitEl.className   = 'bundle-picker__per-unit';
        perUnitEl.textContent = formatMoney(Math.round(bundle.price / bundle.units)) + unitLabel;
        priceBlock.appendChild(perUnitEl);
      }

      card.appendChild(priceBlock);
      row.appendChild(card);

      if (firstCard === null) { firstCard = card; firstBundle = bundle; }

      (function (b, c) {
        c.addEventListener('click', function () { selectCard(row, c, b); });
      }(bundle, card));
    });

    return firstCard ? { section: section, firstBundle: firstBundle } : null;
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    var config = window.bundlePickerConfig;
    if (!config || !config.bundles || config.bundles.length === 0) return;

    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;

    /* Hide Dawn's variant selectors — we render our own UI */
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });

    /* Create standalone price display (replaces Dawn's .price visually) */
    createPriceDisplay();

    var result = buildPicker(config);
    if (!result) return;

    var btns = form.querySelector('.product-form__buttons');
    if (btns) form.insertBefore(result.section, btns);
    else form.appendChild(result.section);

    /* Force button to full width */
    if (btns) {
      btns.style.width    = '100%';
      btns.style.maxWidth = 'none';
      var submitBtn = btns.querySelector('.button, button[type="submit"]');
      if (submitBtn) {
        submitBtn.style.width    = '100%';
        submitBtn.style.maxWidth = 'none';
      }
    }

    /* Pre-select first bundle */
    var fb = result.firstBundle;
    _selectedBundle = fb;
    setVariantId(fb.variantId);

    /* Capture-phase listener: fires BEFORE Dawn's submit handler so we can
       guarantee the correct variant ID is in the form when it submits. */
    var productFormEl = form.closest('product-form') || form.parentElement;
    productFormEl.addEventListener('submit', function () {
      if (_selectedBundle) setVariantId(_selectedBundle.variantId);
    }, true);

    var ca = (fb.compareAtPrice && fb.compareAtPrice > fb.price)
             ? fb.compareAtPrice : null;
    setActivePrice(fb.price, ca);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else setTimeout(init, 300);
})();
